const basePath = '/office';

export const officeRoutes = {
  root: basePath,
  editor: `${basePath}/editor/:fileId`,
} as const;
